<template>
    <div style="height: 100vh; width:100%;">
        <div v-show="loading" style=" display: flex;
  justify-content: center; height: 100%; width:100%;">
        <div class="center">
            <Loader :loading="loading" color="cyan" size="50px"></Loader>
        </div>


        </div>

        <div style="height: 100%; width:100%;" v-show="!loading">
            <!--<v-btn v-if="true"
                class="mx-3"
                elevation="2"
                fab
                medium
                color="white"
                dark
                style="position: fixed; z-index: 2; bottom: 150px; right: 3px; width: 40px; height: 40px; "
                @click="centerMap(center ? center.lat : 25.413056, center ? center.long : -99.178470)"
            >
                 <v-icon medium color="black" >mdi-crosshairs-gps  </v-icon>
            </v-btn>-->

        <GmapMap ref="mapRef" :center="{ lat:25.413056, lng:-99.178470 }"
            :zoom="5"
            :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
                clickableIcons: false,
                scrollwheel: isFullScreen,
                draggable: isFullScreen
            }"
            style=" height: 100%; width:100%;">

            <GmapMarker v-for="center in centers" :key="center.lat"
                :position="{ lat:center.lat, lng:center.long }"
            />
        </GmapMap>
        </div>
        
    </div>
</template>

<script>
import Loader from 'vue-spinner/src/GridLoader.vue'

export default {
    name: "Map",
    components: {
        Loader
    },
    props:{
        url: String,
        multiples: Boolean,
        centers: Array
    },
    watch:{
        multiples(){
            this.newquery = true
        },
        url(){
            this.loading = !this.multiples
            this.$refs.mapRef.$mapPromise.then((map) => {
                if(!this.multiples || this.newquery){
                    this.newquery = false
                    this.kmls.forEach(element => {
                        element.setMap(null);
                    });

                    this.kmls = []
                }

                let options = {
                    map: map,
                    url: this.url,
                    clickable: false
                }
                
                this.kmls.push(new google.maps.KmlLayer(options))
                if(!this.multiples){
                    setTimeout(() =>{map.setZoom(15)}, 2000)
                    setTimeout(() =>{this.loading = false;}, 2050)
                    setTimeout(() =>{this.centerMap(this.centers[0].lat, this.centers[0].long)}, 2100)
                }
            })
        }
    },
    methods:{
        centerMap(lat, lng){
            this.$refs.mapRef.panTo({ lat:lat, lng:lng });
        },
        centerAndZoom(){
            this.$refs.mapRef.setZoom(25);
        }
    },
    data: () => ({
        isFullScreen: true,
        loading: false,
        kmls: [],
        newquery: true,
    })

}
</script>

<style scoped>
::v-deep .vue-map img[draggable="false"] {
  opacity: .8;
}


.center {
  margin: auto;
 padding: 10px;
}

</style>